(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/press-ratings.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/press-ratings.js');
"use strict";


const {
  ListGroup,
  ListItem
} = svs.ui.ReactListGroup;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const EmptyDataView = svs.racing.emptyDataView.EmptyDataView;
const PressRatingsList = _ref => {
  let {
    title,
    rows
  } = _ref;
  return React.createElement(ListGroup, {
    className: "press-ratings-list"
  }, React.createElement(ListItem, {
    className: "press-ratings-list-header"
  }, title), rows.map(row => React.createElement(ListItem, {
    className: "press-ratings-list-item",
    key: row.participantNumber
  }, React.createElement("div", {
    className: "participant-number"
  }, row.participantNumber), React.createElement("div", {
    className: "participant-name f-capitalize"
  }, row.name), React.createElement("div", {
    className: "participant-points"
  }, "".concat(row.points, " p")))));
};
const PressRatings = _ref2 => {
  let {
    pressRatings
  } = _ref2;
  const isMdDown = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  if (!pressRatings.length) {
    return React.createElement(EmptyDataView, {
      isFadeIn: true,
      label: "F\xF6r tillf\xE4llet har vi inga speltips"
    });
  }
  return React.createElement("div", {
    className: "press-ratings-holder"
  }, React.createElement("p", {
    className: "press-ratings-header-text"
  }, "Sammanst\xE4llning av franska tidningars tips"), isMdDown ? React.createElement("div", {
    className: "press-ratings-lists-holder"
  }, pressRatings.map(list => React.createElement(PressRatingsList, {
    key: list.title,
    rows: list.rows,
    title: list.title
  }))) : React.createElement(GridRow, null, React.createElement(GridCol, {
    md: "6"
  }, React.createElement("div", {
    className: "press-ratings-lists-holder"
  }, pressRatings.filter((_, i) => i % 2 === 0).map(list => React.createElement(PressRatingsList, {
    key: list.title,
    rows: list.rows,
    title: list.title
  })))), React.createElement(GridCol, {
    md: "6"
  }, React.createElement("div", {
    className: "press-ratings-lists-holder"
  }, pressRatings.filter((_, i) => i % 2 !== 0).map(list => React.createElement(PressRatingsList, {
    key: list.title,
    rows: list.rows,
    title: list.title
  }))))), React.createElement("p", {
    className: "press-ratings-description"
  }, "Po\xE4ngen f\xF6rdelas enligt f\xF6ljande:", React.createElement("br", null), "8 po\xE4ng till varje h\xE4st placerad p\xE5 f\xF6rsta plats. 7 po\xE4ng f\xF6r den andra, 6 po\xE4ng f\xF6r den tredje, 5 po\xE4ng f\xF6r den fj\xE4rde, 4 po\xE4ng f\xF6r den femte, 3 po\xE4ng f\xF6r den sj\xE4tte, 2 po\xE4ng f\xF6r den sjunde och 1 po\xE4ng f\xF6r den \xE5ttonde h\xE4sten."));
};
svs.racing_game.components.play.PressRatings = PressRatings;

 })(window);